import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Loader } from '../Loader';
const AsyncInputContainer = styled.div`
  display: flex;
  flex-direction: ${p => p.flexDir || 'row'};
`;
export const AsyncInput = ({
  flexDir,
  children,
  hideLoader
}) => {
  const [isLoading, setIsLoading] = useState(false);
  return React.createElement(AsyncInputContainer, {
    flexDir: flexDir
  }, children({
    loaderInit: () => setIsLoading(true),
    loaderEnd: () => setIsLoading(false),
    isLoading
  }), !hideLoader && isLoading && React.createElement(Loader, {
    isCentered: false,
    borderWidth: "5px",
    width: "15px",
    height: "15px",
    marginTop: "0"
  }));
};
AsyncInput.propTypes = {
  hideLoader: PropTypes.bool,
  flexDir: PropTypes.string,
  children: PropTypes.func.isRequired
};
AsyncInput.defaultProps = {
  flexDir: '',
  hideLoader: false
};